import { render, staticRenderFns } from "./KarmaProgramView.vue?vue&type=template&id=49d3cdeb&scoped=true&"
import script from "./KarmaProgramView.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramView.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaProgramView.vue?vue&type=style&index=1&id=49d3cdeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3cdeb",
  null
  
)

export default component.exports